import { createSelector } from '@reduxjs/toolkit';

import { NodeData } from 'src/containers/ProjectDiagram/types/model';
import { entityDrawerSelector } from 'src/selectors/entityDrawer';
import { projectNodeDataArraySelector } from 'src/selectors/projectNodeDataArray';

export const entityDrawerNodeDataSelector = <T extends NodeData>(
  projectId: string,
  isType: (data: any) => data is T
) =>
  createSelector(
    entityDrawerSelector,
    projectNodeDataArraySelector(projectId),
    (drawer, nodeDataArray) =>
      nodeDataArray.find(
        (nodeData): nodeData is T =>
          isType(nodeData) && nodeData.value === drawer.entityValue
      ) || null
  );
